/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Move_Line_UpInputs */

const en_shortcut_keys_name_move_line_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move Line Up`)
};

const fr_shortcut_keys_name_move_line_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer une ligne vers le haut`)
};

const de_shortcut_keys_name_move_line_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufstellung nach oben verschieben`)
};

const it_shortcut_keys_name_move_line_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta la fila`)
};

const ru_shortcut_keys_name_move_line_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместить состав`)
};

const es_shortcut_keys_name_move_line_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover la alineación`)
};

const zh_cn2_shortcut_keys_name_move_line_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移动阵容`)
};

const ja_shortcut_keys_name_move_line_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラインを上に移動`)
};

const hi_shortcut_keys_name_move_line_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइन अप को आगे बढ़ाएं`)
};

const pt_pt2_shortcut_keys_name_move_line_up = /** @type {(inputs: Shortcut_Keys_Name_Move_Line_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mova a fila para cima`)
};

/**
* | output |
* | --- |
* | "Move Line Up" |
*
* @param {Shortcut_Keys_Name_Move_Line_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_move_line_up = /** @type {((inputs?: Shortcut_Keys_Name_Move_Line_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Move_Line_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_move_line_up(inputs)
	if (locale === "de") return de_shortcut_keys_name_move_line_up(inputs)
	if (locale === "it") return it_shortcut_keys_name_move_line_up(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_move_line_up(inputs)
	if (locale === "es") return es_shortcut_keys_name_move_line_up(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_move_line_up(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_move_line_up(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_move_line_up(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_move_line_up(inputs)
	return en_shortcut_keys_name_move_line_up(inputs)
});